<template>
  <!--    执行操作：弹出框框-->
  <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose" :title="dialogTitle" width="70%"
             :modal-append-to-body="true" :append-to-body="true">
    <div id="step_dialog">
      <div style="margin-bottom: 30px">
        <div style="text-align:left;padding-top: 5px;padding-left: 10px;font-size: 18px;margin-bottom: 20px">
          执行状态：
        </div>
        <div style="padding-top: 5px;padding-left: 10px">
          <el-steps :active="executeStepActive" align-center lay-size="mini" class="step-remark">
            <el-step title="已给brief" @click.native="stepClick(0)"></el-step>
            <el-step title="已给脚本" @click.native="stepClick(1)"></el-step>
            <el-step title="脚本定稿" @click.native="stepClick(2)"></el-step>
            <el-step title="已给视频" @click.native="stepClick(3)"></el-step>
            <el-step title="视频定稿" @click.native="stepClick(4)"></el-step>
            <el-step title="已发布" @click.native="stepClick(5)"></el-step>
          </el-steps>
        </div>
      </div>
      <div style="margin-bottom: 30px">
        <div style="text-align:left;padding-top: 5px;padding-left: 10px;font-size: 18px;margin-bottom: 20px">
          销售状态：
        </div>
        <div style="padding-top: 5px;padding-left: 10px">
          <el-steps :active="saleStepActive" align-center lay-size="mini" class="step-remark sale-step">
            <el-step title="已给合同" @click.native="stepClick(0,'sale_step')"></el-step>
            <el-step title="合同已确认" @click.native="stepClick(1,'sale_step')"></el-step>
            <el-step title="合同已寄出" @click.native="stepClick(2,'sale_step')"></el-step>
            <el-step title="已付款" @click.native="stepClick(3,'sale_step')"></el-step>
            <el-step title="合同已归档" @click.native="stepClick(4,'sale_step')"></el-step>
            <el-step title="已开票" @click.native="stepClick(5,'sale_step')"></el-step>
          </el-steps>
        </div>
      </div>
      <div style="margin-bottom: 30px">
        <div
            style="text-align:left;padding-top: 5px;padding-left: 10px;font-size: 18px;margin-bottom: 20px;font-weight: 800">
          完成时间&发布链接
          <!--            <span style="font-size: 14px;color: #999">(分成比例：{{ execForm.rate }}%)</span>：-->
        </div>
        <div class="form-card">
          <ExecForm :form-data.sync="formData" @loadFormData="loadFormData"/>
          <PublishLinkForm :form-data.sync="formData" @loadFormData="loadFormData"/>
        </div>

      </div>
    </div>
  </el-dialog>
</template>

<script>
import {getOrderDetailExec} from "@/api/order";
import {stepRemark} from "@/api/adOrder";
import ExecForm from "@/views/adOrder/components/detail/ExecForm";
import PublishLinkForm from "@/views/adOrder/components/detail/PublishLinkForm";

export default {
  name: "ExecDialog",
  components: {PublishLinkForm, ExecForm},
  props: {
    orderId: {
      type: [Number, String],
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        id: null,
        bool_exec: null,
        exec_timestamp: null,
        publish_link: []
      },
      publishLinkArr: [],
      stepRemarkRow: {},
      executeStepActive: 0,
      saleStepActive: 0,

    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    dialogTitle() {
      return `执行记录`
    }
  },
  methods: {
    onOpen() {
      this.loadFormData()
    },
    onClose() {
      // this.$refs['elForm'].resetFields()
      this.$emit('close')
    },
    close() {
      this.$emit('update:visible', false)
    },
    async loadFormData() {
      this.loading = true
      //获取订单信息 getOrderDetailBase
      let {info} = await getOrderDetailExec({id: this.orderId}).then((res) => {
        return res.model;
      })
      info.publish_link = info.publish_link || ['']
      info.publish_link = typeof info.publish_link === 'string' ? [info.publish_link] : info.publish_link
      this.formData = info
      this.executeStepActive = info.execute_step || 0
      this.saleStepActive = info.sale_step || 0
      this.loading = false
      this.$forceUpdate()
    },
    stepClick(index, field = 'execute_step') {
      if ((index === this.executeStepActive && field === 'execute_step') || (index === this.saleStepActive && field === 'sale_step')) {
        if (!this.userAuth.can_execute_step_remark && field === 'execute_step') {
          this.showToast({
            h: this,
            icon: 'el-icon-warning',
            text: '不能操作执行状态'
          })
          return;
        }
        if (!this.userAuth.can_sale_step_remark && field === 'sale_step') {
          this.showToast({
            h: this,
            icon: 'el-icon-warning',
            text: '不能操作销售状态'
          })
          return;
        }

        let step = field === 'execute_step' ? this.executeStepActive : this.saleStepActive
        stepRemark({
          id: this.orderId,
          field: field,
          step: ++step
        }).then(() => {
          if (field === 'execute_step')
            this.executeStepActive++
          else
            this.saleStepActive++
        })
      }
    },
  }
}
</script>

<style scoped>

</style>
